export var SortingEnum;
(function (SortingEnum) {
    SortingEnum["BestFit"] = "Best fit";
    SortingEnum["PriceAsc"] = "Price ascending";
    SortingEnum["PriceDesc"] = "Price descending";
})(SortingEnum || (SortingEnum = {}));
export const getTranslationKeyFromSortingEnum = (sortingEnum) => {
    switch (sortingEnum) {
        case SortingEnum.BestFit:
            return 'Sorting.BestFit';
        case SortingEnum.PriceAsc:
            return 'Sorting.PriceAscending';
        case SortingEnum.PriceDesc:
            return 'Sorting.PriceDescending';
        default:
            return '';
    }
};
//# sourceMappingURL=SortingEnum.js.map